import { useLocation } from 'react-router-dom';
import { PARISH_DETAILS_CONTEXT_MODE, PARISH_DETAILS_QUERY_PARAM } from '@/routing/routesAliases';

export const useIsLimitedClusterSubView = (): boolean => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  return queryParams.get(PARISH_DETAILS_QUERY_PARAM.CONTEXT_MODE) === PARISH_DETAILS_CONTEXT_MODE.CLUSTER_ONE;
};
